<header class="modal-header">
  <h5 class="modal-title">
    {{ headerKey }}
  </h5>
</header>
<form [formGroup]="form" class="form" (ngSubmit)="emitFormValue()">
  <div class="modal-body">
    <app-domain-error class="mb-6"></app-domain-error>

    <div class="mb-4" *ngFor="let formItem of formControls">
      <label class="form-label">
        {{ formItem.labelKey }}
        <ng-container *ngIf="formItem.required">
          <span class="text-danger">*</span>
        </ng-container>
      </label>
      <input [type]="formItem.type" class="form-control" [formControlName]="formItem.formControlName" />

      <ng-container *ngIf="formItem.required">
        <small *ngIf="shouldDisplayTypeOfError(formItem.formControlName, 'required')" class="form-text text-danger" i18n
          >To pole jest wymagane.</small
        >
      </ng-container>
      <ng-container *ngIf="otherValidatorsExist">
        <small
          *ngIf="shouldDisplayTypeOfError(formItem.formControlName, formItem.otherValidators.type)"
          class="form-text text-danger"
        >
          <div [ngSwitch]="formItem.otherValidators.type">
            <ng-container *ngSwitchCase="'maxlength'" i18n>Przekroczono dopuszczalną liczbę znaków.</ng-container>
            <ng-container *ngSwitchCase="'minlength'" i18n>Wymagana jest większa liczba znaków.</ng-container>
            <ng-container *ngSwitchCase="'max'" i18n>Przekroczono dopuszczalną wartość.</ng-container>
            <ng-container *ngSwitchCase="'min'" i18n>Wymagana jest większa wartość.</ng-container>
          </div>
        </small>
      </ng-container>
    </div>
  </div>
  <footer class="modal-footer">
    <button ndt-tertiary-button type="button" (click)="modalRef.hide()" i18n>Anuluj</button>
    <button ndt-primary-button type="submit" [disabled]="form.invalid || isSaving" i18n>Zapisz</button>
  </footer>
</form>
